/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type StorageKanbanBoardQueryVariables = {};
export type StorageKanbanBoardQueryResponse = {
    readonly storageKanban: {
        readonly id: string;
        readonly columns: Record<string, any>;
    };
};
export type StorageKanbanBoardQuery = {
    readonly response: StorageKanbanBoardQueryResponse;
    readonly variables: StorageKanbanBoardQueryVariables;
};



/*
query StorageKanbanBoardQuery {
  storageKanban {
    id
    columns
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StorageKanban",
    "kind": "LinkedField",
    "name": "storageKanban",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "columns",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StorageKanbanBoardQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "StorageKanbanBoardQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "2ac528cba868a9221db428a9dae01ebb",
    "id": null,
    "metadata": {},
    "name": "StorageKanbanBoardQuery",
    "operationKind": "query",
    "text": "query StorageKanbanBoardQuery {\n  storageKanban {\n    id\n    columns\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b0ce6263fdbca603afd2b4e1dd6015a1';
export default node;
